// extracted by mini-css-extract-plugin
export default {"nav-group":"styles__nav-group__kgHw1","navGroup":"styles__nav-group__kgHw1"};